export default __webpack_public_path__ + "static/media/hip.582baa96.png";